const IOS_USER_AGENT_RE = /iPad|iPhone|iPod/i;

/**
 * Detects iOS/iPadOS from a User-Agent string.
 * iPadOS 13+ in desktop mode may report "Macintosh" without "Mobile";
 * pass maxTouchPoints from the client when available.
 */
export function isIOSUserAgent(userAgent: string, maxTouchPoints = 0): boolean {
  if (IOS_USER_AGENT_RE.test(userAgent)) {
    return true;
  }

  return /Macintosh/i.test(userAgent) && maxTouchPoints > 1;
}

export function getClientPlatformHints(): {
  userAgent: string;
  maxTouchPoints: number;
} {
  if (typeof navigator === "undefined") {
    return { userAgent: "", maxTouchPoints: 0 };
  }

  return {
    userAgent: navigator.userAgent,
    maxTouchPoints: navigator.maxTouchPoints ?? 0,
  };
}

export function isIOSClient(userAgent?: string): boolean {
  const { userAgent: clientUserAgent, maxTouchPoints } =
    getClientPlatformHints();

  return isIOSUserAgent(userAgent ?? clientUserAgent, maxTouchPoints);
}
